import StripePaymentForm from '~/components/payments/StripePaymentForm';
import ErrorMessage from '~/components/ErrorMessage';
import SquarePaymentForm from '~/components/payments/SquarePaymentForm';

const PaymentForm = ({
    type,
    id,
    paymentSettings,
    paymentBtnLabel,
    paymentElementContainerClassName,
}) => {
    const isStripe = paymentSettings?.processor === 'stripe';
    const isSquare = paymentSettings?.processor === 'square';

    return (
        <>
            {isStripe && (
                <StripePaymentForm
                    type={type}
                    id={id}
                    paymentSettings={paymentSettings}
                    paymentBtnLabel={paymentBtnLabel}
                    paymentElementContainerClassName={
                        paymentElementContainerClassName
                    }
                />
            )}
            {isSquare && (
                <SquarePaymentForm
                    type={type}
                    id={id}
                    paymentSettings={paymentSettings}
                    paymentBtnLabel={paymentBtnLabel}
                    paymentElementContainerClassName={
                        paymentElementContainerClassName
                    }
                />
            )}
            {!isSquare && !isStripe && (
                <ErrorMessage>Error, unknown payment processor</ErrorMessage>
            )}
        </>
    );
};

export default PaymentForm;
